export default "__VITE_ASSET__BMpNm67B__"